module.exports = __webpack_public_path__ + "static/img/conversion.cb75555a.png";